<!--
 * @Author: 张天昊
 * @Date: 2024-05-27 17:00:56
 * @LastEditTime: 2024-06-04 11:10:21
 * @LastEditors: 张天昊
 * @Description: 备注
 * @FilePath: /Mobile/src/pages/itineraryUniversal/components/BaseInfoRemark.vue
-->
<script>
import 'vue-overflow-ellipsis/dist/index.css';
import { defineComponent, ref, computed } from 'vue';
import Ellipsis from 'vue-overflow-ellipsis';
import { genEmptyTextPlaceholder } from '../utils';
import store from '@/store';
import SvgIcon from '../../../components/SvgIcon.vue';
export default defineComponent({
  components: { SvgIcon, Ellipsis },
  setup() {
    const detailInfoRemark = computed(() =>
      store.state.itineraryUniversal.detailInfo.value
        ? store.state.itineraryUniversal.detailInfo.value.itineraryInfoMessage
            .remark || ''
        : ''
    );
    const popupShow = ref(false);
    const ellipsisInst = ref();
    function onClick() {
      const isTextOverflow =
        ellipsisInst.value.textLength < detailInfoRemark.value.length;
      if (isTextOverflow) {
        popupShow.value = true;
      }
    }
    function onClose() {
      popupShow.value = false;
    }
    return {
      detailInfoRemark,
      ellipsisInst,
      popupShow,
      onClick,
      onClose,
      genEmptyTextPlaceholder
    };
  }
});
</script>

<template>
  <div class="mt-4">
    <Ellipsis
      ref="ellipsisInst"
      :style="{ lineHeight: $px2rem(20) }"
      :content="`备注：${genEmptyTextPlaceholder(detailInfoRemark)}`"
      class="text-14 text-white"
      @click.native="onClick"
    >
      <template #ellipsis>
        ...
        <span
          class="ml-6 text-14 leading-20 text-white inline-flex items-center van-haptics-feedback"
          >全部<span
            class="bg-green-a ml-3 w-12 h-12 rounded-full inline-flex justify-center items-center"
            ><svg-icon
              pre-path="itineraryUniversal"
              name="ic-arrow"
              class="w-10 h-10 stroke-white" /></span
        ></span>
      </template>
    </Ellipsis>
    <van-popup
      v-model="popupShow"
      class="rounded-tl-8 rounded-tr-8"
      position="bottom"
    >
      <div class="px-20 text-black-primary">
        <header class="py-21 text-18 leading-26 font-semibold relative">
          备注<svg-icon
            pre-path="itineraryUniversal"
            name="ic-bottom-popup-close"
            class="absolute top-20 right-0 w-28 h-28"
            @click="onClose"
          />
        </header>
        <div
          :style="{ maxHeight: `calc(89vh - ${$px2rem(68)})` }"
          class="text-14 leading-22 pb-20 overflow-y-auto"
          v-html="detailInfoRemark.replace(/(\n)+/g, '<br>')"
        />
      </div>
    </van-popup>
  </div>
</template>
